import React, { useEffect, useState } from "reactn";
import { useParams, useHistory } from 'react-router-dom'
import { Table, Space, Button, message, Modal, Card, Row, Form, Col, List } from 'antd';
import ExportJsonExcel from 'js-export-excel';
import { Link } from 'react-router-dom';
import firebaseDb from '../firebase';
import { ImportExcel } from './../components';
import { doc, getDoc, collection, getDocs, setDoc } from 'firebase/firestore';
import { EditOutlined, Loading3QuartersOutlined, LeftOutlined, PlusOutlined, DownloadOutlined } from "@ant-design/icons";

const StreamCodes = (props) => {
    let params = useParams()
    let id = params.id !== "add" ? params.id : false;
    let [data, setData] = useState([]);
    let [totalCount, setTotalCount] = useState(0)
    let [loading, setLoading] = useState(false);
    let [excelData, setExcelData] = useState([]);
    let [modalData, setModalData] = useState(null);

    const history = useHistory();
    let handleTableChange = async (page, filters, sorter) => {
        get(page, filters, sorter);
    }

    let get = async () => {
        let answerRef = collection(firebaseDb, "code/" + id + "/codes")
        const docsSnap = await getDocs(answerRef);
        let datas = []
        for (const document of docsSnap.docs) {
            let code = { id: document.id, ...document.data(), code: document.id };
            let remainder = code.limit
            if (code.users) {
                remainder = code.limit - code.users.length
            }
            datas.push({ ...code, remainder: remainder })
        }
        setData(datas);
        setTotalCount(datas.length);
        setLoading(false)
    }

    useEffect(() => {
        setLoading(true)
        get();
    }, [])

    useEffect(() => {
        uploadExcel();
    }, [excelData]);

    let uploadExcel = async () => {
        let updateCount = 0;
        let insertCount = 0;

        if (excelData) {
            let validData = []
            for (let i in excelData) {

                let valid
                const codeRef = doc(firebaseDb, "code/" + id + "/codes", excelData[i].code.toString());
                await getDoc(codeRef).then(codeSnap => {
                    if (codeSnap.exists()) {
                        validData.push(excelData[i].code)
                    }
                    else {
                        setDoc(doc(firebaseDb, "code/" + id + "/codes", excelData[i].code.toString()), { users: [], limit: excelData[i].limit || 1 });
                        insertCount++;
                    }
                })
            }

            if (validData.length > 0)
                setModalData(validData)
            else
                setModalData(null)

            if (updateCount || insertCount) {
                message.success("Excel Yüklendi. " + insertCount + " Kayıt Eklendi.", 2);
            }
        }
        get()
    }

    let templateExcel = async () => {
        var option = {};

        let sheetAreas = ['code', 'limit']
        option.fileName = "template"
        option.datas = [
            {
                sheetData: ['code', 'limit'],
                sheetName: 'sheet',
                sheetFilter: ['code', 'limit'],
                sheetHeader: ['code', 'limit'],
                sheetFilter: sheetAreas,
                sheetHeader: sheetAreas,
            }
        ];

        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
    }

    let columns = [
        {
            title: 'Kod',
            dataIndex: 'code',
            key: 'code',
            width: 150,
        },
        {
            title: 'Limit',
            dataIndex: 'limit',
            key: 'limit',
            width: 150,
        },
        {
            title: 'Kalan ',
            dataIndex: 'remainder',
            key: 'remainder',
            width: 150,
        },
        {
            title: 'Kullanılan ',
            dataIndex: 'remainder',
            key: 'used',
            width: 150,
            render: (_, record) => {
                const used = (record.limit || 0) - (record.remainder || 0);
                return used;
            },
        },
        {
            title: '',
            key: 'action',
            fixed: 'right',
            align: 'right',
            className: 'editColumn',
            width: 150,
            render: (text, record) => (
                <Space size="small">
                    <Link to={"/streams/codes/" + id + "/edit/" + record.id}>
                        <Button className="button-consultant" icon={<EditOutlined />}>Detay</Button>
                    </Link>
                </Space>
            )
        }
    ];

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Kodlar"} </h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Button size="large" className="button4" onClick={templateExcel} icon={<DownloadOutlined />}>Template Excel</Button>

                    <ImportExcel setExcelData={setExcelData} />
                    <Link to={"/streams/codes/" + id + "/add"}>
                        <Button type="light" className="button4" icon={<PlusOutlined />} size="large">Kod Ekle</Button>
                    </Link>
                    <Link to="/streams">
                        <Button className="button4" type="light" icon={<LeftOutlined />} size="large">GERİ</Button>
                    </Link>
                </div>
            </div>
            <div className="table-wrap">
                <Table dataSource={data} columns={columns} loading={{ spinning: loading, indicator: <Loading3QuartersOutlined spin />, size: "large" }}
                    onChange={handleTableChange}
                    pagination={{
                        total: totalCount
                    }}
                />
                <p>Toplam Sayı : {totalCount}</p>
            </div>
            {modalData &&
                <div>
                    <Modal
                        visible={true}
                        onOk={() => setModalData(null)}
                        onCancel={() => setModalData(null)}>
                        <Card loading={modalData ? false : true} >
                            <Form>
                                <Row direction="row">
                                    <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                        <Form.Item>
                                            <List
                                                itemLayout="horizontal"
                                                dataSource={modalData}
                                                renderItem={item => (
                                                    <List.Item>
                                                        <List.Item.Meta
                                                            title={<a>{item}</a>}
                                                        />
                                                    </List.Item>
                                                )}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <p>Belirtilen kodlar zaten kullanılıyor. Limit artırımı için düzenleme işlemi yapınız!</p>
                                </Row>
                            </Form>
                        </Card>
                    </Modal>
                </div>
            }
        </div>
    );
};

export default StreamCodes;
